/* eslint-env browser */
import * as React from 'react'

import { getCDNUrl } from '../../../../../../shared/services/media-helper'

const PropTypes = require('prop-types')
const classNames = require('classnames')

class MediaCarousel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: 0,
    }
    this.goPrev = this.goPrev.bind(this)
    this.goNext = this.goNext.bind(this)
    this.onTouchStart = this.onTouchStart.bind(this)
    this.onTouchEnd = this.onTouchEnd.bind(this)
  }

  onTouchStart(e) {
    const tch = e.changedTouches[0]
    this.startX = tch.pageX
    this.startY = tch.pageY
  }

  onTouchEnd(e) {
    const tch = e.changedTouches[0]
    const distY = Math.abs(tch.pageY - this.startY)
    const distX = tch.pageX - this.startX
    if (distY < 100) {
      if (distX > 0) {
        this.goPrev()
      } else {
        this.goNext()
      }
    }
  }

  goPrev(e) {
    if (e) {
      e.preventDefault()
    }
    this.setState(prevState => ({ selected: prevState.selected - 1 }))
  }

  goNext(e) {
    if (e) {
      e.preventDefault()
    }
    this.setState(prevState => ({ selected: prevState.selected + 1 }))
  }

  render() {
    const { selected } = this.state
    const { medias, isCover, figureClassName, imageMaxHeight, imageHeight } = this.props

    let order = selected % medias.length
    if (order < 0) {
      order = medias.length + order
    }
    const transform = `translateX(${-order * 100}%)`

    return (
      <div className="carousel" onTouchStart={this.onTouchStart} onTouchEnd={this.onTouchEnd}>
        <ul style={{ transform }}>
          {medias.map((media, index) => (
            <div key={media.id} style={{ order: index }}>
              <figure className={classNames('image', figureClassName)}>
                <img
                  src={getCDNUrl(media, 'original')}
                  className={classNames('animated fadeIn faster', {
                    'has-object-fit-cover': isCover,
                    'has-object-fit-contain': !isCover,
                  })}
                  alt={media.alt || ''}
                  style={{ maxHeight: imageMaxHeight, height: imageHeight }}
                  itemProp="image"
                />
              </figure>
            </div>
          ))}
        </ul>
        {medias.length > 1 && selected > 0 && (
          <div
            role="button"
            onClick={this.goPrev}
            tabIndex="-1"
            onKeyPress={this.goPrev}
            type="button"
            className={classNames(['carousel-nav-arrow carousel-nav-arrow-left'])}
          >
            <span className="icon is-medium small-shadow-left">
              <i className="fas fa-chevron-left" />
            </span>
          </div>
        )}
        {medias.length > 1 && selected < medias.length - 1 && (
          <div
            role="button"
            onClick={this.goNext}
            onKeyPress={this.goNext}
            tabIndex="0"
            type="button"
            className={classNames(['carousel-nav-arrow carousel-nav-arrow-right'])}
          >
            <span className="icon is-medium small-shadow">
              <i className="fas fa-chevron-right" />
            </span>
          </div>
        )}
      </div>
    )
  }
}

MediaCarousel.propTypes = {
  medias: PropTypes.array.isRequired,
  isCover: PropTypes.bool,
  figureClassName: PropTypes.string,
  imageMaxHeight: PropTypes.any,
  imageHeight: PropTypes.any,
}

MediaCarousel.defaultProps = {
  isCover: true,
  figureClassName: null,
  imageMaxHeight: null,
  imageHeight: null,
}

module.exports = MediaCarousel
